<template lang="pug">
  v-dialog(v-model='mode.serviceDialog' persistent scrollable fullscreen)
    div(style='width:inherit')
      v-card(height='100%')
        v-toolbar(color='primary' dense dark extension extension-height='30px')
          v-btn(@click.stop='vibrate();close()' icon)
            v-icon mdi-close
          v-toolbar-title.ma-0 [{{mode.sectionCode}}]{{formTitle(&apos;Service&apos;)}}
          v-spacer
          v-btn(icon)
            v-icon(v-if='tab===0' :disabled='!isDirty' @click.stop='vibrate();save(dialogKey)') mdi-check
            v-icon(v-if='tab===0 && editedItem.status===STATUSES.CREATED && !isDirty' @click.stop='vibrate();deleteItem(dialogKey)') mdi-delete
            v-icon(v-if='tab===3 && !editedItem.billText' @click.stop='vibrate();saveBill()') mdi-content-save
            v-icon(v-if='tab===3 && editedItem.status > STATUSES.ACTIVE && editedItem.billText' @click.stop='vibrate();editedItem.billText=null;') mdi-redo
          v-icon(v-if='tab===3 && editedItem.billText' @click.stop='vibrate();print(editedItem.billText)') mdi-printer
          template(v-slot:extension)
            v-tabs(v-model='tab' background-color='primary' height='30px')
              v-tabs-slider(color='pink')
              v-tab.pl-2.pr-2 Seats({{editedItem.seats.length}})
              v-tab.pl-2.pr-2(:disabled='!editedItem.seats.length') Cart({{cartOrders.length}})
              v-tab.pl-2.pr-2(:disabled='editedItem.status===STATUSES.INACTIVE') Track({{trackOrders.length}})
              v-tab.pl-2.pr-2(:disabled='editedItem.status===STATUSES.INACTIVE') Bill
              v-tab.pl-2.pr-2(:disabled='editedItem.status===STATUSES.INACTIVE') Payment
        v-card-text.pa-0
          v-tabs-items(v-model='tab')
            v-tab-item
              v-row.pa-0(justify-left no-gutters)
                v-col(xs='12' sm='6' md='4' lg='3' x='l2')
                  div(transition='slide-y-reverse-transition')
                    v-form.pl-3.pr-3(ref='service')
                      v-form-base#serviceForm(:value='editedItem' :schema='schema' @input:serviceForm='onFormInput')
                        v-divider.pb-1(slot='slot-top-key-seats')
                        floor-plan.pa-0(slot='slot-item-key-seats' align='center' :tables='selectedSection.tables' :options="{mode:'view', serviceId: editedItem.id }" @onSelectSeat='handleSeat(selectedSection, $event )')
                        v-divider(slot='slot-bottom-key-seats')
            v-tab-item
              e-z-cart(:showCart='showCart' :sectionKey='selectedSection.id' :sectionCode='selectedSection.code' :serviceKey='editedItem.id' :seats='seats' @activated='activateService()')
            v-tab-item
              e-z-track
            v-tab-item
              e-z-bill(v-if='tab===3' ref='bill' :billText="editedItem.status > STATUSES.ACTIVE ?editedItem.billText:''" @billShown='editedItem.status <= STATUSES.ACTIVE && saveBill()' @update='editedItem.amountReceivable=$event')
            v-tab-item
              v-row.pa-0(justify-left no-gutters)
                v-col(xs='12' sm='6' md='4' lg='3' x='l2')
                  e-z-payment(v-if='tab===4' :payments='editedItem.payments || []' :amount='editedItem.amountReceivable' @updated='savePayment()')
</template>

<script>
import { storeMixin } from "../../mixins/storeMixin.js";
import EZCart from "../panels/EZCart.vue";
import EZTrack from "../panels/EZTrack.vue";
import EZBill from "../panels/EZBill.vue";
import EZPayment from "../panels/EZPayment.vue";
import { dialogsMixin } from "../../mixins/dialogsMixin.js";

export default {
  name: "service-dialog",
  mixins: [storeMixin, dialogsMixin],
  components: { EZCart, EZTrack, EZBill, EZPayment },
  beforeMount() {
    if (!this.editedItem.id) {
      Object.assign(this.editedItem, this.defaultItem);
    }
    this.selectService(this.editedItem);
    this.slurpSelectedSeats();
    this.tab = this.getDefaultActiveTab();
    // this.bindRestaurantProducts();
  },
  data() {
    return {
      collectionName: "services",
      dialogKey: "serviceDialog",
      defaultItem: {
        name: "",
        customerName: "",
        mobile: "",
        seats: [],
        billText: "",
        amountReceivable: "",
        payments: [],
        notes: "",
        status: 0
      },
      tab: 1,
      showCart: { show: true }
    };
  },
  computed: {
    cartOrders() {
      return this.serviceOrders.filter(o => o.status === this.STATUSES.INCART);
    },
    trackOrders() {
      return this.serviceOrders.filter(o => o.status > this.STATUSES.INCART);
    },
    billText() {
      return this.editedItem.billText || this.$refs.bill
        ? this.$refs.bill.generate()
        : "";
    },
    seats() {
      const seats = [];
      this.editedItem.seats.forEach(s => {
        let [tidx, sidx] = s.split("-");
        seats.push(`T${Number(tidx) + 1}S${Number(sidx) + 1}`);
      });
      return seats;
    },
    schema() {
      return Object.assign(
        {
          _groupKey: { type: "text", hidden: true },
          _restaurantKey: { type: "text", hidden: true },
          _sectionKey: { type: "text", hidden: true },
          sectionCode: { type: "text", hidden: true },
          billText: { type: "text", hidden: true },
          amountReceivable: { type: "text", hidden: true },
          payments: { type: "text", hidden: true },
          mobile: {
            type: "text",
            label: "Guest's Mobile#",
            flex: 4,
            sort: 1,
            rules: [
              this.required("Mobile number is required"),
              this.minLen(10),
              this.maxLen(40)
            ]
          },
          customerName: {
            type: "text",
            label: "Guest's Name",
            flex: 6,
            offset: 2,
            sort: 2,
            rules: [
              this.required("Guest's name is required"),
              this.minLen(10),
              this.maxLen(40)
            ]
          },
          name: {
            type: "text",
            disabled: true,
            label: "Service name:",
            flex: 12,
            sort: 3,
            rules: [
              this.required("Service name is required"),
              this.minLen(10),
              this.maxLen(40)
            ]
          },
          count: {
            type: "text",
            label: "Count",
            flex: 2,
            offset: 1,
            sort: 4,
            rules: [
              this.required("Remaining count is required"),
              this.maxLen(3)
            ]
          },
          seats: { type: "text", sort: 3, flex: 12, hidden: false },
          status: {
            type: "select",
            label: "Status",
            items: ["Draft", "Active", "Paid", "Closed"],
            flex: 3,
            sort: 5,
            rules: [this.required("Status is required")],
            hidden: true
          },
          notes: {
            type: "textarea",
            label: "Notes",
            flex: 8,
            offset: 1,
            sort: 6,
            rules: [this.maxLen(200)]
          }
        },
        this.baseSchema
      );
    }
  },
  methods: {
    getDefaultActiveTab() {
      const tab = this.$route.params.tab;
      return tab ? Number(tab) : this.serviceOrders.length ? 1 : 0;
    },
    activateService() {
      this.editedItem.status = this.STATUSES.ACTIVE;
      this.updateFields({
        collectionName: "services",
        docId: this.editedItem.id,
        subDoc: { status: this.editedItem.status }
      });
    },
    slurpSelectedSeats() {
      const seats = [];
      const tables = this.selectedSection.tables;
      for (let [tidx, t] of tables.entries()) {
        for (let [sidx] of t.seats.entries()) {
          if (tables[tidx].seats[sidx]._serviceKey === this.editedItem.id) {
            seats.push([tidx, sidx].join("-"));
          }
        }
      }
      this.editedItem.seats = seats;
    },
    async handleSeat(section, { _serviceKey, tidx, sidx }) {
      const tables = section.tables;
      if (!_serviceKey) {
        if (
          await this.$confirm("Do you want to add this seat to the service?")
        ) {
          tables[tidx].seats[sidx]._serviceKey = this.selectedService.id;
          this.isDirty = true;
        }
      } else if (_serviceKey === this.selectedService.id) {
        if (
          this.selectedService.seats.length > 1 &&
          (await this.$confirm(
            "Do you want to remove this seat from the service?"
          ))
        ) {
          tables[tidx].seats[sidx]._serviceKey = "";
          this.isDirty = true;
        }
      } else {
        this.$emit("switch", _serviceKey);
        this.tab = 2;
      }
      if (this.isDirty) {
        this.slurpSelectedSeats();
        this.save();
        this.$forceUpdate();
        this.isDirty = false;
      }
    },
    saveBill() {
      this.editedItem.billText = this.billText;
      this.editedItem.amountReceivable =
        this.editedItem.amountReceivable || this.$refs.bill
          ? this.$refs.bill.calcTotalAmount()
          : "";
      this.editedItem.payments = this.editedItem.payments || [];
      this.updateFields({
        collectionName: "services",
        docId: this.editedItem.id,
        subDoc: {
          billText: this.editedItem.billText,
          amountReceivable: this.editedItem.amountReceivable,
          payments: this.editedItem.payments
        }
      });
      this.$forceUpdate();
      this.isDirty = false;
    },
    savePayment() {
      if (this.getPaymentBalance() <= 0) {
        this.editedItem.status = this.STATUSES.PAID;
        this.selectedSection.tables.forEach(t => {
          t.seats.forEach(s => {
            if (this.editedItem.id === s._serviceKey) {
              delete s._serviceKey;
            }
          });
        });
        this.editedItem.seats = [];
        //Mark all Orders as PAIDINSERVICE.
        this.restaurantOrders
          .filter(o => o._serviceKey === this.editedItem.id)
          .forEach(o => {
            o.status = this.STATUSES.PAIDINSERVICE;
            this.updateFields({
              collectionName: "orders",
              docId: o.id,
              subDoc: { status: o.status }
            });
          });
      }
      this.save();
      this.$forceUpdate();
      this.isDirty = false;
    },
    getPaymentBalance() {
      let pd = 0;
      this.editedItem.payments.forEach(p => (pd += Number(p.amount)));
      return parseFloat(Number(this.editedItem.amountReceivable) - pd).toFixed(
        2
      );
    },
    close() {
      if (
        this.$route.name === "sectionService" ||
        this.$route.name === "sectionServiceTab" ||
        !this.myFeatures.eligibleFeatures.includes("WORKFLOW")
      ) {
        this.$router.push("/home");
      } else {
        this.cancel(this.dialogKey);
      }
    }
  }
};
</script>